export default __webpack_public_path__ + "static/media/tabuleiro.056e03a1.webp";